import { getAuth, onAuthStateChanged } from "firebase/auth";

let cachedToken = null;
let tokenExpiry = 0;

export const apiFetch = async (url, options = {}) => {
  const auth = getAuth();
  const now = Date.now();

  if (!cachedToken || now > tokenExpiry) {
    const user = auth.currentUser || await new Promise(resolve => {
      onAuthStateChanged(auth, u => resolve(u));
    });

    cachedToken = user ? await user.getIdToken(true) : null; // force refresh
    tokenExpiry = now + 55 * 60 * 1000; // 55 min
  }

  const headers = {
    "Content-Type": "application/json",
    ...(cachedToken && { Authorization: `Bearer ${cachedToken}` }),
    ...options.headers,
  };

  const response = await fetch(url, { ...options, headers });

  if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

  return response;
};
